"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES = void 0;
var SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES;
(function (SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES) {
    SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES[SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES["ON_MOUSE_OVER"] = 1] = "ON_MOUSE_OVER";
    SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES[SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES["ALWAYS"] = 2] = "ALWAYS";
})(SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES = exports.SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES || (exports.SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES = {}));
//# sourceMappingURL=show-expanded-video-list-titles.js.map